import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  tableContainer: {
    maxHeight: '20vh'
  },
  tags: {
    borderRadius: '14px'
  },
  tagMod1: {
    color: '#FFFFFF',
    backgroundColor: '#0F89FF'
  }
}))
